import * as DomTypeUtils from '@packages/systems/core/utils/DomTypeUtils';
import type {Context} from '../types';

// Make sure elements that can't have descendants have no children
export default (context: Context) => {
  const {
    node: {jsonNode},
    // eslint-disable-next-line webflow/deprecated
    fn: {__DEPRECATED__dropChildren},
  } = context;
  const {data = {}} = jsonNode;
  const hasDynBoundHtml = DomTypeUtils.isDynBoundHtml(data);
  const isSymbolInstance = DomTypeUtils.isSymbolInst(data);
  const isTextArea = DomTypeUtils.isFormTextarea(data);
  const hasChildren = Boolean(jsonNode.children && jsonNode.children.length);
  const cannotHaveChildren = hasDynBoundHtml || isSymbolInstance || isTextArea;

  return {
    needed: cannotHaveChildren && hasChildren,
    logData: {
      msg: `Node has children, but shouldn't`,
      meta: {
        hasDynBoundHtml,
        isSymbolInstance,
        isTextArea,
        nodeId: jsonNode._id,
      },
    },
    apply: () => {
      __DEPRECATED__dropChildren(jsonNode);
    },
  };
};
